import { WorkforceProfileOFOCodeSummary } from "../../../../../Model/Dto/WSP/WorkforceProfileOFOCodeSummary";
import { TableColumn } from "../../../../../Model/Table/Table";
import { DefaultCell } from "../../../DataTable/DefaultCell";

interface WorkforceProfileOFOCodeTableRow {
    ofoCodes: string;
    africanMales: number;
    africanFemales: number;
    colouredMales: number;
    colouredFemales: number;
    indianMales: number;
    indianFemales: number;
    whiteMales: number;
    whiteFemales: number;
    nonSAMales: number;
    nonSAFemales: number;
    total: number;
}

export interface IWorkforceProfileOFOCodeTable {
    columns: Array<TableColumn>;
    rows: Array<WorkforceProfileOFOCodeTableRow>;
}

export function WorkforceProfileOFOCodeTableMapper(data: WorkforceProfileOFOCodeSummary[]): IWorkforceProfileOFOCodeTable {
    const columns = [
        { Header: 'OFO Codes', accessor: 'ofoCodes', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="150px" />, disableSortBy: true },
        { Header: 'African Male', accessor: 'africanMales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'African Female', accessor: 'africanFemales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'Coloured Male', accessor: 'colouredMales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'Coloured Female', accessor: 'colouredFemales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'Indian Male', accessor: 'indianMales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'Indian Female', accessor: 'indianFemales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'White Male', accessor: 'whiteMales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'White Female', accessor: 'whiteFemales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'NON RSA Male', accessor: 'nonSAMales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'NON RSA Female', accessor: 'nonSAFemales', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
        { Header: 'Total', accessor: 'total', Cell: ({ value }: any) => <DefaultCell value={value} maxWidth="50px" />, disableSortBy: true },
    ];


    if (data.length >= 0) {
        const rows: WorkforceProfileOFOCodeTableRow[] = data.map((item: WorkforceProfileOFOCodeSummary) => (
            {
                ofoCodes: item.label,
                africanMales: item.headcount.africanMales,
                africanFemales: item.headcount.africanFemales,
                colouredMales: item.headcount.colouredMales,
                colouredFemales: item.headcount.colouredFemales,
                indianMales: item.headcount.indianMales,
                indianFemales: item.headcount.indianFemales,
                whiteMales: item.headcount.whiteMales,
                whiteFemales: item.headcount.whiteFemales,
                nonSAMales: item.headcount.nonSAMales,
                nonSAFemales: item.headcount.nonSAFemales,
                total: item.totalHeadcount
            }));

        return { columns: columns, rows: rows };
    } else {
        return { columns: columns, rows: [] };
    }
}